import { useTranslation } from "react-i18next";
import React from "react";

interface PriceDetailsProps {
  subtotal: number;
  discount: number;
  vat: number;
  total: number;
}

const PriceDetails: React.FC<PriceDetailsProps> = ({
  subtotal,
  discount,
  vat,
  total,
}) => {
  const { t } = useTranslation();
  return (
    <div className="border p-4">
      <div className="flex justify-between">
        <span>{t("Subtotal")}</span>
        <span>${subtotal}</span>
      </div>
      <div className="flex justify-between">
        <span>{t("Discount")}</span>
        <span>-${discount}</span>
      </div>
      <div className="flex justify-between">
        <span>{t("VAT")}</span>
        <span>${vat}</span>
      </div>
      <div className="flex justify-between font-bold">
        <span>{t("Total")}</span>
        <span>${total}</span>
      </div>
    </div>
  );
};

export default PriceDetails;
